import React from 'react';
import './style.css';

export default ({ href, title, onClick, children, thumbnail = null}) => (
    <a href={href} className="VideoButton" target="_blank" onClick={event => { event.preventDefault(); onClick(children); }} style={ thumbnail ? { backgroundImage: `url(${thumbnail})` } : null }>
        <div className="VideoButton-icon">
            <span className="fa fa-caret-square-o-right"></span>
        </div>
        <span className="VideoButton-title">{title}</span>
    </a>);



// WEBPACK FOOTER //
// ./src/common/input/VideoButton/index.js